<header id="cx-header-mobile" class="cx-header-mobile" cxSkipLink="cx-header-mobile" [cxFocus]="{ disableMouseFocus: true }">
  <div class="container">
    <div class="content">
      <icon-hamburguer></icon-hamburguer>
      <cx-page-layout section="headerAuxMobile"></cx-page-layout>
    </div>
  </div>

  <div class="main">
    <div class="container">
      <cx-page-layout section="subMenuMobile"></cx-page-layout>
    </div>
  </div>
</header>
